<template>

  <nav class="navigation">

    <MenuGroup :title="$t('general.navigation_title')" :menuitems="menus" v-if="status != 'guest'"/>

    <div class="navigation--secondary">
      <a href="#" class="navigation__item" @click.prevent="logout" v-if="status != 'guest'">
        <i class="icon--lock"></i>{{ $t('general.logout') }}
      </a>
      <LanguagePicker/>
    </div>

  </nav>

</template>

<script>
import LanguagePicker from '@/components/Parts/LanguagePicker.vue'
import menu from '@/data/menu'
import { MENU_ROUTE_PERMISSION } from '@/constants'
import MenuGroup from '@/components/Parts/MenuGroup'

export default {
  name: 'Navigation',
  props: ['status'],
  components: {
    MenuGroup,
    LanguagePicker
  },
  data () {
    return {
      menus: menu
    }
  },
  computed: {
    menuRoute () {
      return MENU_ROUTE_PERMISSION
    }
  },
  methods: {
    async logout () {
      await this.$store.dispatch('auth/logout')
      this.$router.replace({ name: 'auth.login' })
    }
  }
}
</script>
